/* Live store hours on /pages/drop-off-points.
 *
 * This logic used to live in a <script> inside the page body, which is how
 * the design ships to both themes without publishing. On 2026-09-03 the
 * owner made a text edit in Shopify's page editor and the save stripped the
 * entire <script>, every data-xgd-* attribute, and left a stray <br> inside
 * each hours div. The <style> block survived, and so did every class. So:
 * the CSS stays in the page body (it renders on the live theme today), the
 * behaviour moves here where the editor cannot reach it, and nothing it
 * needs is keyed on an attribute the editor might drop again.
 *
 * Cards are found by class; the city comes from the card's own visible
 * heading ("Charlottetown, PE" -> "charlottetown"); the hours container is
 * reused if present and created if not. sections/page.liquid loads this
 * only on a page whose body contains .xgdrop.
 */
(function () {
  try {
    var root = document.querySelector('.xgdrop');
    if (!root || !window.fetch) return;
    var cards = [].slice.call(root.querySelectorAll('.xgdrop__card'));
    if (!cards.length) return;
    var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var SHORT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var WEEK = 10080;
    var feed = null;

    function isTime(t) { t = String(t == null ? '' : t); return t.length === 4 && !isNaN(Number(t)); }
    function mins(t) { return parseInt(t.slice(0, 2), 10) * 60 + parseInt(t.slice(2, 4), 10); }
    function fmt(t) {
      var h = parseInt(t.slice(0, 2), 10), m = parseInt(t.slice(2, 4), 10);
      var h12 = h % 12; if (h12 === 0) h12 = 12;
      return h12 + (m ? ':' + (m < 10 ? '0' + m : m) : '') + ' ' + (h >= 12 ? 'pm' : 'am');
    }
    function offset(s) { return typeof s.utcOffsetMin === 'number' ? s.utcOffsetMin : 0; }
    function localDay(s, now) { return new Date(now + offset(s) * 60000).getUTCDay(); }

    /* Shift now into the store's local time, read the UTC getters, and wrap
       every period modulo a 10080-minute week so a Saturday-into-Sunday
       close is still "open now". */
    function status(s, now) {
      var hrs = s && s.hours;
      if (!hrs || !hrs.periods || !hrs.periods.length) return null;
      var d = new Date(now + offset(s) * 60000);
      var cur = d.getUTCDay() * 1440 + d.getUTCHours() * 60 + d.getUTCMinutes();
      var ps = [], i, p;
      for (i = 0; i < hrs.periods.length; i++) {
        p = hrs.periods[i];
        if (p && p.open && typeof p.open.day === 'number' && isTime(p.open.time)) ps.push(p);
      }
      if (!ps.length) return null;
      for (i = 0; i < ps.length; i++) {
        p = ps[i];
        if (p.close == null) return { open: true, detail: 'open 24 hours' };
        if (!p.close || !isTime(p.close.time) || typeof p.close.day !== 'number') continue;
        var o = p.open.day * 1440 + mins(p.open.time);
        var c = p.close.day * 1440 + mins(p.close.time);
        var len = ((c - o) % WEEK + WEEK) % WEEK; if (len === 0) len = WEEK;
        if (((cur - o) % WEEK + WEEK) % WEEK < len) return { open: true, detail: 'closes ' + fmt(p.close.time) };
      }
      var best = null, bestRel = WEEK + 1;
      for (i = 0; i < ps.length; i++) {
        p = ps[i];
        var rel = ((p.open.day * 1440 + mins(p.open.time) - cur) % WEEK + WEEK) % WEEK;
        if (rel < bestRel) { bestRel = rel; best = p; }
      }
      if (!best) return { open: false, detail: '' };
      var sameDay = best.open.day === d.getUTCDay() && bestRel < 1440;
      // Show the whole window, not just the opening time: "opens 10 am - 6 pm"
      // answers "how late are you open" without a second click. When the next
      // opening is not today, the day leads so the two times stay together.
      var ok = best.close && isTime(best.close.time);
      var span = fmt(best.open.time) + (ok ? ' – ' + fmt(best.close.time) : '');
      return { open: false, detail: 'opens ' + (sameDay ? '' : SHORT[best.open.day] + ' ') + span };
    }

    /* "Charlottetown, PE" -> "charlottetown". The heading is the card's own
       visible text, so it survives anything the editor does to attributes. */
    function keyOf(card) {
      var el = card.querySelector('.xgdrop__city') || card.querySelector('.xgdrop__addr');
      var txt = el ? String(el.textContent || '') : '';
      var cut = txt.indexOf(',');
      if (cut > 0) txt = txt.slice(0, cut);
      return txt.replace(/^[\s]+|[\s]+$/g, '').toLowerCase();
    }

    function pick(list, key) {
      var i, s;
      if (!key) return null;
      for (i = 0; i < list.length; i++) {
        s = list[i];
        if (s && s.city && String(s.city).toLowerCase().indexOf(key) === 0) return s;
      }
      for (i = 0; i < list.length; i++) {
        s = list[i];
        if (!s) continue;
        var hay = (String(s.name || '') + ' ' + String(s.address || '')).toLowerCase();
        if (hay.indexOf(key) !== -1) return s;
      }
      return null;
    }

    /* Reuse the page's own hours div when it is there, create one when it is
       not, and empty it either way - the editor's save left a <br> inside. */
    function boxOf(card) {
      var box = card.querySelector('.xgdrop__hours');
      if (!box) {
        box = document.createElement('div');
        box.className = 'xgdrop__hours';
        var foot = card.querySelector('.xgdrop__foot');
        if (foot && foot.parentNode) foot.parentNode.insertBefore(box, foot);
        else (card.querySelector('.xgdrop__body') || card).appendChild(box);
      }
      while (box.firstChild) box.removeChild(box.firstChild);
      box.hidden = false;
      box.removeAttribute('hidden');
      return box;
    }

    function row(dayName, timeText, isToday) {
      var r = document.createElement('div');
      r.className = 'r' + (isToday ? ' is-today' : '');
      var dt = document.createElement('dt'); dt.textContent = dayName;
      var dd = document.createElement('dd'); dd.textContent = timeText;
      r.appendChild(dt); r.appendChild(dd);
      return r;
    }

    /* Everything below is createElement + textContent on purpose: the feed is
       remote, so nothing from it is ever parsed as markup. */
    function paint(card, s, now) {
      var st = status(s, now);
      if (!st) return;
      var box = boxOf(card);
      var pill = document.createElement('span');
      pill.className = 'xgdrop__pill ' + (st.open ? 'is-open' : 'is-closed');
      var dot = document.createElement('i');
      var word = document.createElement('b');
      word.textContent = st.open ? 'Open now' : 'Closed';
      pill.appendChild(dot); pill.appendChild(word);
      if (st.detail) {
        var tail = document.createElement('span');
        tail.textContent = '· ' + st.detail;
        pill.appendChild(tail);
      }
      box.appendChild(pill);
      var wt = s.hours && s.hours.weekdayText;
      if (wt && wt.length) {
        var today = DAYS[localDay(s, now)].toLowerCase();
        var det = document.createElement('details');
        det.className = 'xgdrop__week';
        var sum = document.createElement('summary');
        sum.textContent = 'All hours';
        det.appendChild(sum);
        var dl = document.createElement('dl');
        for (var i = 0; i < wt.length; i++) {
          var line = String(wt[i] || '').replace(/^[\s]+|[\s]+$/g, '');
          if (!line) continue;
          var cut = line.indexOf(':');
          var dayName = cut > 0 ? line.slice(0, cut) : line;
          var timeText = cut > 0 ? line.slice(cut + 1).replace(/^[\s]+|[\s]+$/g, '') : '';
          dl.appendChild(row(dayName, timeText, dayName.toLowerCase() === today));
        }
        det.appendChild(dl);
        box.appendChild(det);
      }
      if (s.phone) {
        var foot = card.querySelector('.xgdrop__foot');
        if (foot && !foot.querySelector('.xgdrop__tel')) {
          var tel = document.createElement('a');
          tel.className = 'xgdrop__go xgdrop__tel';
          tel.href = 'tel:' + String(s.phone).replace(/[^0-9+]/g, '');
          tel.textContent = String(s.phone);
          foot.appendChild(tel);
        }
      }
    }

    function paintAll() {
      if (!feed) return;
      var now = Date.now();
      for (var i = 0; i < cards.length; i++) {
        var s = pick(feed, keyOf(cards[i]));
        if (s) { try { paint(cards[i], s, now); } catch (e) {} }
      }
    }

    var ctl = ('AbortController' in window) ? new AbortController() : null;
    var timer = ctl ? setTimeout(function () { try { ctl.abort(); } catch (e) {} }, 7000) : null;
    fetch('https://exor-binder.nevski.workers.dev/stores.json', { signal: ctl ? ctl.signal : undefined })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
      .then(function (d) {
        if (timer) clearTimeout(timer);
        if (!d || d.ok !== true || !d.stores || !d.stores.length) return;
        feed = d.stores;
        paintAll();
        setInterval(function () { try { paintAll(); } catch (e) {} }, 60000);
        document.addEventListener('visibilitychange', function () { if (!document.hidden) { try { paintAll(); } catch (e) {} } });
      })
      .catch(function () { if (timer) clearTimeout(timer); });
  } catch (err) {}
})();